import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonAddComponent } from '@component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from '@component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from '@component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from '@component/button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from '@component/button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonDeleteComponent } from '@component/button-delete/button-delete.component';
import { ButtonSaveComponent } from '@component/button-save/button-save.component';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ExpedienteDto } from '@models/expediente/expedienteDto.model';
import { CreateExpedienteVinculadoRequest } from '@models/expedienteVinculado/createExpedienteVinculadoRequest.model';
import { UpdateExpedienteVinculadoRequest } from '@models/expedienteVinculado/updateExpedienteVinculadoRequest.model';
import { ExpedienteVinculadoService } from '@services/expedienteVinculado/expedienteVinculado.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { BuscarLocalidadGeorefComponent } from '@views/busquedas/buscar-localidad-georef/buscar-localidad-georef.component';
import { BuscarLocalidadComponent } from '@views/busquedas/buscar-localidad/buscar-localidad.component';
import { BuscarProvinciaGeorefComponent } from '@views/busquedas/buscar-provincia-georef/buscar-provincia-georef.component';
import { BuscarProvinciaLocalidadGeorefComponent } from '@views/busquedas/buscar-provincia-localidad-georef/buscar-provincia-localidad-georef.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dialog-form-expediente-vinculado',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatInputModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule,  ButtonAddComponent, BuscarExpedienteComponent],
  templateUrl: 'dialog-form-expediente-vinculado.component.html',
  styleUrl: './dialog-form-expediente-vinculado.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogFormExpedienteVinculadoComponent {

  accionesDialog = AccionesDialog;
  expedienteVinculado: any;
  expedienteDto!: ExpedienteDto;
  idExpediente!: number;
  get f() { return this.form.controls; }
  form!: FormGroup;
  localData: any;
  formBuilder: FormBuilder = new FormBuilder;

  constructor(
    public dialogRef: MatDialogRef<DialogFormExpedienteVinculadoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private expedienteVinculadoService: ExpedienteVinculadoService,
  ) {

  }

  ngOnInit(): void {
    this.expedienteVinculado = this.data || {};
    this.idExpediente = this.data.idExpediente
    this.setForm();
  }
  setForm() {
    const esEdicion = this.data.accion === AccionesDialog.Modificar;

    this.form = this.formBuilder.group({
      Id: [{ value: this.expedienteVinculado?.id || null}],
      IdExpediente: [ null, Validators.required],
      IdExpedienteVinculado: [null, Validators.required],
    });

    if (this.idExpediente)
      this.form.controls['IdExpediente'].setValue(this.idExpediente);

  }
  selectExpediente($event: any) {
    this.expedienteDto = $event
    if (this.expedienteDto.id)
      this.form.controls['IdExpedienteVinculado'].setValue(this.expedienteDto.id);
  }

  cancelar() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar, data: this.data });
  }



  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spExpedienteVinculado")
    this.expedienteVinculadoService.create(this.setCreateRequest())
      .subscribe(
        data => {
          this.spinner.hide("spExpedienteVinculado")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data });
        },
        error => {
          this.spinner.hide("spExpedienteVinculado")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spExpedienteVinculado")
    this.expedienteVinculadoService.update(this.setUpdateRequest())
      .subscribe(
        data => {
          this.spinner.hide("spExpedienteVinculado")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data });
        },
        error => {
          this.spinner.hide("spExpedienteVinculado")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spExpedienteVinculado")
    this.expedienteVinculadoService.delete(this.expedienteVinculado?.id)
      .subscribe(
        data => {
          this.spinner.hide("spExpedienteVinculado")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.usuario });
        },
        error => {
          this.spinner.hide("spExpedienteVinculado")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateRequest(): CreateExpedienteVinculadoRequest {

    const createExpedienteVinculadoRequest = new CreateExpedienteVinculadoRequest();

    createExpedienteVinculadoRequest.idExpediente = this.form.controls['IdExpediente'].value ?? this.idExpediente;
    createExpedienteVinculadoRequest.idExpedienteVinculado = this.form.controls['IdExpedienteVinculado'].value;

    return createExpedienteVinculadoRequest
  }

  setUpdateRequest(): UpdateExpedienteVinculadoRequest {

    const updateExpedienteVinculadoRequest = new UpdateExpedienteVinculadoRequest();

    updateExpedienteVinculadoRequest.id = this.form.controls['Id'].value;
    updateExpedienteVinculadoRequest.idExpediente = this.form.controls['IdExpediente'].value;
    updateExpedienteVinculadoRequest.idExpedienteVinculado = this.form.controls['IdExpedienteVinculado'].value;

    return updateExpedienteVinculadoRequest
  }



  onReset() {
    this.form.reset();
  }

  trackByusuarios(index: number, usuario: any): any { return usuario; }
}
